import type { RouteObject } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import CategoryPage from "@/pages/category/page";
import TagPage from "@/pages/tag/page";
import DetailPage from "@/pages/detail/page";
import NewsPage from "@/pages/news/page";
import NewsDetailPage from "@/pages/news/detail/page";
import SearchPage from "@/pages/search/page";
import FavoritesPage from "@/pages/favorites/page";
import AboutPage from "@/pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: "category/:type", element: <CategoryPage /> },
      { path: "tag/:tagname", element: <TagPage /> },
      { path: "detail/:id", element: <DetailPage /> },
      { path: "news", element: <NewsPage /> },
      { path: "news/:id", element: <NewsDetailPage /> },
      { path: "search", element: <SearchPage /> },
      { path: "favorites", element: <FavoritesPage /> },
      { path: "about", element: <AboutPage /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;